import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import { setCustomerID } from "../../actions";
import Swal from "sweetalert2";
import MainHelper from "../../helpers/MainHelper";
import ExcelJS from 'exceljs';
import SupplierCariTransactionsTable from "../../components/Tables/SupplierCariTransactionsTable";
import { Dropdown } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";
import SupplierPaymentTransactionsTable from "../../components/Tables/SupplierPaymentTransactionsTable";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
class CustomerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: [],
      summery: [],
      banks: [],
      branches: [],
      calculates: [],
      cariByCompany: [],
      cariTransactions: [],
      showCariTransactions: false,
      isLoad: true,
      loading: false,
      filterLoading: false,
      deleteFromParasutLoading: false,
      isAddPaymetModalOpen: false,
      paymentLoading: false,
      collectionUpdateLoading: false,
      editIndex: null,
      editedRow: {},
      formData: {
        id: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        tax_district: '',
        tax_no: '',
        title: '',
        city_id: '',
        district_id: '',
        is_supplier: '',
        p_id: '',
        save_parasut: false,
        urn: '',
      },
      paymentData: {
        amount: '',
        branch_id: '',
        collection_date: '',
        payment_type: '',
        description: '',
        bank_id: '',
      },
      cariByCompanyFilter: {
        time: '',
        start_time: '',
        end_time: '',
      },
      totalPaid: '',
      totalReceived: '',
      totalDebt: '',
      totalCredit: '',
      balance: '',
      cities: [],
      districts: []
    }
  }
  async componentDidMount() {
    this.getCustomerInfo();
    this.getCariTransactonsSummery();
    this.getCities();
    this.getBanks();
    this.setState({
      branches: await getBranches(),
    });
  }
  getCustomerInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/customer/info/' + id, 'get', null);
      this.props.setCustomerID(response.id)
      this.setState({ customer: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key]
      });
      const dist = await apiCall(`get-dist/${response.city_id}`, 'get', null);
      this.setState({ formData: updatedData, districts: dist, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  getCariTransactonsSummery = async () => {
    const id = this.props.match.params.id;
    try {
      if (id) {
        const response = await apiCall('business/receivable/supplier/get-balance/' + id, 'get', null);
        this.setState({ summery: response }, () => { });
      }
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  getCities = async () => {
    const response = await apiCall('get-cities', 'get', null);
    this.setState({ cities: response });
  }
  handleCityChange = async (event) => {
    const city_id = event.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        city_id: city_id,
        district_id: ""
      },
      districts: []
    }));

    if (city_id) {
      const response = await apiCall(`get-dist/${city_id}`, 'get', null);
      this.setState({ districts: response });
    }
  }
  handleChange = (e) => {
    const { id, type, checked, value } = e.target;

    let inputValue;
    if (type === 'checkbox') {
      inputValue = !!checked;
    } else {
      inputValue = value;
    }

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: inputValue
      }
    }));
  };
  handlePaymentChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      paymentData: {
        ...prevState.paymentData,
        [id]: value
      }
    }));
  };
  handleFilterChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      cariByCompanyFilter: {
        ...prevState.cariByCompanyFilter,
        [id]: value
      }
    }));
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const customerFormData = new FormData();
    Object.keys(formData).forEach(key => {
      customerFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/customer/update/' + formData.id, 'post', customerFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  handlePaymentSubmit = async (e) => {
    e.preventDefault();
    this.setState({ paymentLoading: true });
    const { paymentData } = this.state;
    const paymentFormData = new FormData();
    Object.keys(paymentData).forEach(key => {
      paymentFormData.append(key, paymentData[key]);
    });

    try {
      const response = await apiCall('business/receivable/supplier/add-payment/' + this.state.formData.id, 'post', paymentFormData);
      await this.getCariTransactonsSummery();
      this.setState({ paymentLoading: false, isAddPaymetModalOpen: false });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ paymentLoading: false });
    }

  }
  checkTaxPayer = async () => {
    try {
      Swal.fire({
        title: 'Sorgulama Yapılıyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const checkGibCredentials = await apiCall('business/customer/check-gib', 'get', null);
      if (!checkGibCredentials.gib_usercode || !checkGibCredentials.gib_password) {
        Swal.close();
        Swal.fire({
          title: 'Uyarı!',
          text: 'Gib kullanıcı kodu ve şifre girilmemiş.Ayarlar->işletme ayarları, içerisinden ekledikten sonra tekrar deneyiniz!',
          icon: 'warning',
          confirmButtonText: 'Tamam',
        });
        return;
      }
      const response = await apiCall('business/customer/check-taxpayer/' + this.state.formData.tax_no, 'get', null);

      const { unvan, adi, soyadi, vergiDairesi } = response;

      const messages = [];
      if (unvan) messages.push(`Ünvan: ${unvan}`);
      if (adi) messages.push(`Adı: ${adi}`);
      if (soyadi) messages.push(`Soyadı: ${soyadi}`);
      if (vergiDairesi) messages.push(`Vergi Dairesi: ${vergiDairesi}`);
      const text = messages.join('\n');

      if (messages.length === 0) {
        Swal.fire({
          title: 'Uyarı!',
          text: 'Mükellefe ait veri bulunamadı.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
      } else {

        Swal.fire({
          title: 'İşlem tamamlandı!',
          text: text,
          icon: 'success',
          confirmButtonText: 'Tamam'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Hata!',
        text: 'Veriler alınırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  }
  allReceivablesWithCollections = async () => {
    try {
      Swal.fire({
        title: 'Sorgulama Yapılıyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await apiCall('business/receivable/by-company/' + this.state.formData.id, 'get', null);
      if (response.length === 0) {
        Swal.fire({
          title: 'Uyarı!',
          text: 'Müşteri/Tedarikçi ye ait veri bulunamadı.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
      }
      this.setState({ cariByCompany: response });
      Swal.close();
    } catch (error) {
      Swal.fire({
        title: 'Hata!',
        text: 'Veriler alınırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  }
  handleFilterSubmit = async (e) => {
    e.preventDefault();
    if (this.state.cariByCompanyFilter.time && (this.state.cariByCompanyFilter.start_time || this.state.cariByCompanyFilter.end_time)) {
      Swal.fire({
        title: 'Uyarı',
        text: 'Periyod seçili iken tarih seçilmemelidir!',
        icon: 'warning',
        confirmButtonText: 'Tamam'
      });
      return;
    }
    this.setState({ filterLoading: true });
    const { cariByCompanyFilter } = this.state;
    const filterFormData = {
      time: cariByCompanyFilter.time,
      end_time: cariByCompanyFilter.end_time,
      start_time: cariByCompanyFilter.start_time
    };

    try {
      const response = await apiCall('business/receivable/supplier/by-company-filter/' + this.state.formData.id, 'post', filterFormData);

      this.setState({
        cariByCompany: response.data,
        calculates: response.calcs,
        filterLoading: false
      });
    } catch (e) {
      console.error(e)
      this.setState({ filterLoading: false });
    }
  }
  exportToExcel = (cariByCompany, totals) => {
    const { calculates } = this.state;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Cari Hareketler');

    const addReceivableHeaders = (worksheet) => {
      const headerRow = worksheet.addRow(["ID", "Tutar", "Ödeme Türü", "Tip", "Ödeme Tarihi", "Banka", "Açıklama"]);
      headerRow.eachCell((cell) => {
        cell.font = { bold: false };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0070C0' }
        };
        cell.font = { color: { argb: 'FFFFFFFF' } };
      });
    };

    cariByCompany.forEach((receivable) => {
      addReceivableHeaders(worksheet);

      worksheet.addRow([
        receivable.id,
        receivable.amount,
        receivable.payment_type,
        "Borç",
        MainHelper.dateFormat(receivable.collection_date).split(' 0')[0],
        receivable.bank?.name || "Belirtilmemiş",
        receivable.description
      ]);

    });

    worksheet.addRow([]);

    worksheet.addRow(["", "Özet Bilgiler"]);
    worksheet.addRow(["", "Toplam Borç", calculates.total_debt || 0]);
    worksheet.addRow(["", "Ödenen", calculates.total_paid_debt || 0]);
    worksheet.addRow(["", "Bakiye", calculates.total_balance || 0]);

    const summaryRowStart = worksheet.lastRow.number - 5;
    for (let i = summaryRowStart; i <= worksheet.lastRow.number; i++) {
      const row = worksheet.getRow(i);
      row.eachCell((cell) => {
        cell.font = { bold: true };
      });
    }

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = this.state.formData.name + '.xlsx' || this.state.formData.title + '.xlsx';
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };
  getBanks = async () => {
    try {
      const response = await apiCall('business/settings/bank-account-list', 'get', null);

      this.setState({ banks: response });
    } catch (e) {
      console.error("API çağrısında bir hata oluştu:", e);
    }
  };
  handleCollectionEditClick = (index, receivable) => {
    this.setState({
      editIndex: index,
      editedRow: { ...receivable },
    });
  };
  handleCollectionInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name + ' ' + value)
    this.setState((prevState) => ({
      editedRow: {
        ...prevState.editedRow,
        [name]: value,
      },
    }));
  };
  handleCollectionSave = async () => {
    this.setState({
      collectionUpdateLoading: true
    });
    const { editedRow } = this.state;
    const formData = {
      '_version': editedRow.version,
      'customer_id': editedRow.customer_id,
      'amount': editedRow.amount,
      'collection_date': editedRow.collection_date,
      'payment_type': editedRow.payment_type,
      'description': editedRow.description,
      'bank_id': editedRow.bank_id
    }
    try {
      const response = await apiCall('business/receivable/supplier/update-collection/' + editedRow.id, 'post', formData);
      this.setState({
        collectionUpdateLoading: false
      });
      this.handleCancel();
      await this.getCariTransactonsSummery();
      const fakeEvent = { preventDefault: () => { } };
      await this.handleFilterSubmit(fakeEvent);
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      console.error(e)
      this.setState({ collectionUpdateLoading: false });
    }
  };
  handleCancel = () => {
    this.setState({ editIndex: null, editedRow: {} });
  };
  handleCollectionDelete = async (colId) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/receivable/supplier/delete-payment/' + colId, 'delete');
          await this.getCariTransactonsSummery();
          const fakeEvent = { preventDefault: () => { } };
          await this.handleFilterSubmit(fakeEvent);
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Silindi!',
          'Alacak başarıyla silindi.',
          'success'
        );
      } else {
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  }
  render() {
    const { formData, loading, districts, cities, summery, cariByCompany, filterLoading, banks, isAddPaymetModalOpen, branches, paymentLoading } = this.state;
    const { userPermissions, subscriptionCode } = this.props;
    const userHasUpdateCustomerPermission = userPermissions.includes('update customer');
    const userHasNewReceivablePermission = userPermissions.includes('new receivable');
    const userHasNewReceivablePaymentPermission = userPermissions.includes('new receivable payment');
    const { editIndex, editedRow } = this.state;
    const code = subscriptionCode !== "none" && subscriptionCode !== "t22Vh3S";
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}>
        <div className={isAddPaymetModalOpen ? "modal fade show" : "modal fade"} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">
                  Ödeme veya Tahsilat ekle
                </h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                      name="amount"
                      id="amount"
                      type="number"
                      className="form-control"
                      placeholder="Tahsilat/Ödeme Tutarı Giriniz"
                      value={this.state.paymentData.amount}
                      onChange={this.handlePaymentChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <select
                    id='branch_id'
                    name='branch_id'
                    className="form-control"
                    value={formData.branch_id}
                    onChange={this.handlePaymentChange}>
                    <option value="">Şube Seçiniz</option>
                    {branches && (branches.map(branch => (
                      <option key={branch.id}
                        value={branch.id}>{branch.name}</option>
                    )))}
                  </select>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <select
                      name="payment_type"
                      id="payment_type"
                      className="form-control"
                      value={this.state.paymentData.payment_type}
                      onChange={this.handlePaymentChange}>
                      <option value="">Ödeme Tipi Seçiniz</option>
                      <option value="Nakit">Nakit</option>
                      <option value="Kredi Kartı">Kredi Kartı</option>
                      <option value="Havale/EFT">Havale/EFT</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                      name="collection_date"
                      id="collection_date"
                      type="date"
                      className="form-control"
                      value={this.state.paymentData.collection_date}
                      onChange={this.handlePaymentChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <select name="bank_id" id='bank_id' className="form-control"
                    onChange={this.handlePaymentChange}>
                    <option value="">Banka Seçiniz</option>
                    {banks && (banks.map(bank => (
                      <option key={bank.id} value={bank.id}>{bank.name}</option>
                    )))}

                  </select>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <textarea
                      name="description"
                      id="description"
                      placeholder="Açıklama"
                      className="form-control"
                      value={this.state.paymentData.description}
                      onChange={this.handlePaymentChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">

                {paymentLoading ? (
                  <button className="btn btn-outline-primary btn-lg" disabled={true}
                    style={{ textAlign: "-webkit-center" }}>
                    Lütfen Bekleyin...
                    <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />
                  </button>
                ) : (
                  <button type="button" className="btn btn-outline-primary" onClick={this.handlePaymentSubmit}>
                    Ekle
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => this.setState({ isAddPaymetModalOpen: false })}
                  className="btn btn-simple"
                  data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>

        </div>
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText={"Tedarikçi Detayları"}
              Breadcrumb={[
                {
                  name: "Tedarikçiler",
                  navigate: "suppliers"
                },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <h6>Temel Bilgiler</h6>
                      {/*<div className="text-right">
                        <label className="font-weight-bold text-cyan">{this.state.formData.p_id ? 'Paraşüt Müşteri ID:' + this.state.formData.p_id : ""}</label>
                      </div>*/}
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="is_supplier" className="font-weight-bold text-cyan">
                              Tip
                            </label>
                            <select
                              className="form-control"
                              id="is_supplier"
                              value={this.state.formData.is_supplier}
                              onChange={this.handleChange}>
                              <option value="">Tip Seçiniz</option>
                              <option value="0">Müşteri</option>
                              <option value="1">Tedarikçi</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <label htmlFor="name" className="font-weight-bold text-cyan">
                              Ad
                            </label>
                            <input
                              id="name"
                              className="form-control"
                              placeholder="Ad"
                              type="text"
                              value={formData.name}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="surname" className="font-weight-bold text-cyan">
                              Soyad
                            </label>
                            <input
                              id="surname"
                              className="form-control"
                              placeholder="Soyad"
                              type="text"
                              value={formData.surname}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="Email" className="font-weight-bold text-cyan">
                              Email
                            </label>
                            <input
                              id="email"
                              className="form-control"
                              placeholder="Email"
                              type="email"
                              value={formData.email}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="phone" className="font-weight-bold text-cyan">
                              Telefon
                            </label>
                            <input
                              id="phone"
                              className="form-control"
                              placeholder="Telefon"
                              type="text"
                              value={formData.phone}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="city_id" className="font-weight-bold text-cyan">
                              İl
                            </label>
                            <select
                              className="form-control"
                              id="city_id"
                              value={formData.city_id}
                              onChange={this.handleCityChange}>
                              <option value="">İl Seçiniz</option>
                              {cities && (cities.map(city => (
                                <option key={city.id}
                                  value={city.id}>{city.name}</option>
                              )))}
                            </select>
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="title" className="font-weight-bold text-cyan">
                              Ünvan
                            </label>
                            <input
                              id="title"
                              className="form-control"
                              placeholder="Ünvan"
                              value={formData.title}
                              type="text"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="tax_district" className="font-weight-bold text-cyan">
                              Vergi No
                            </label>
                            <input
                              id="tax_no"
                              className="form-control"
                              placeholder="Vergi No"
                              value={formData.tax_no}
                              type="number"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="address" className="font-weight-bold text-cyan">
                              Adres
                            </label>
                            <textarea
                              id="address"
                              className="form-control"
                              placeholder="Adres"
                              value={formData.address}
                              onChange={this.handleChange}>
                            </textarea>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-12">

                          <div className="form-group">
                            <label htmlFor="district_id" className="font-weight-bold text-cyan">
                              İlçe
                            </label>
                            <select
                              className="form-control"
                              id="district_id"
                              value={formData.district_id}
                              onChange={this.handleChange}>
                              <option value="">İlçe Seçiniz</option>
                              {districts && (districts.map(district => (
                                <option key={district.id}
                                  value={district.id}>{district.name}</option>
                              )))}
                            </select>
                          </div>
                          <div className="form-group">
                            <label htmlFor="tax_district" className="font-weight-bold text-cyan">
                              Vergi Dairesi
                            </label>
                            <input
                              id="tax_district"
                              className="form-control"
                              placeholder="Vergi Dairesi"
                              value={formData.tax_district}
                              type="text"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="urn" className="font-weight-bold text-cyan">
                              Fatura Urn Adresi
                            </label>
                            <input
                              id="urn"
                              className="form-control"
                              placeholder="Fatura Urn Adresi"
                              value={formData.urn}
                              type="text"
                              onChange={this.handleChange}
                            />
                          </div>


                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">

                          {loading ? (
                            <button className="btn btn-outline-primary btn-block" disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateCustomerPermission}
                              className="btn btn-outline-primary btn-block" type="submit">
                              Güncelle
                            </button>}
                          {this.state.formData.tax_no && this.state.formData.tax_no.trim() !== "" && (
                            <button onClick={this.checkTaxPayer} className="btn btn-outline-warning btn-block"
                              type="button">
                              Mükellef Doğrula
                            </button>
                          )}

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>Cari Geçmişi</h2>
                    {code && userHasNewReceivablePermission && (
                      <Dropdown as="ul" className="header-dropdown">
                        <Dropdown.Toggle
                          variant="success"
                          as="li"
                          id="dropdown-basic"
                        >
                          <i className="icon-plus text-success p-1 ml-1"></i>
                          <Dropdown.Menu
                            as="ul"
                            className="dropdown-menu dropdown-menu-right"
                          >
                            <li>
                              <Link to="/receivable-supplier-add">Yeni Alacak/Borç Kaydı</Link>
                            </li>

                          </Dropdown.Menu>
                        </Dropdown.Toggle>
                      </Dropdown>
                    )}
                  </div>
                  {code ? (
                    <>
                      <div className="mt-3">
                        <div className="col-lg-12">
                          {this.state.formData.id && (
                            <SupplierCariTransactionsTable></SupplierCariTransactionsTable>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 mb-3">
                        <div className="col-md-12 text-right">

                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Borç:</b> {formattedPrice(summery.total_debt) || 0}
                          </p>

                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Ödenen:</b> {formattedPrice(summery.total_payed_debt) || 0}
                          </p>

                          <p className="m-b-0 mt-2 ml-3">
                            <b>Bakiye:</b> {formattedPrice(summery.balance) || 0} {summery.balance < 0 ? "(Borç)" : "(Alacak)"}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="body">
                      <div className="col-lg-12 justify-content-center d-flex">
                        <div className="col-md-6 text-center">
                          <div className="alert alert-danger"><i className="icon-ban"></i> Bu özelliği kullanmak için plan yükseltin! </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>Ödeme Geçmişi</h2>
                    {code && userHasNewReceivablePaymentPermission && (
                      <Dropdown as="ul" className="header-dropdown">
                        <Dropdown.Toggle
                          variant="success"
                          as="li"
                          id="dropdown-basic"
                        >
                          <i className="icon-plus text-success p-1 ml-1"></i>
                          <Dropdown.Menu
                            as="ul"
                            className="dropdown-menu dropdown-menu-right"
                          >
                            <li>
                              <a href="#!" onClick={(e) => {
                                e.preventDefault()
                                this.getBanks()
                                this.setState({ isAddPaymetModalOpen: true })
                              }}>Yeni Ödeme Girişi</a>
                            </li>

                          </Dropdown.Menu>
                        </Dropdown.Toggle>
                      </Dropdown>
                    )}

                  </div>
                  {code ? (
                    <div className="mt-3">
                      <div id="payment_table" className="col-lg-12">
                        {this.state.formData.id && (
                          <SupplierPaymentTransactionsTable></SupplierPaymentTransactionsTable>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="body">
                      <div className="col-lg-12 justify-content-center d-flex">
                        <div className="col-md-6 text-center">
                          <div className="alert alert-danger"><i className="icon-ban"></i> Bu özelliği
                            kullanmak için plan yükseltin!
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>Dönem ve Tarihe göre Ödeme Hareketleri (Excell)</h2>
                    <div className="text-right m-2">
                      {Object.keys(this.state.cariByCompany).length > 0 && code && (
                        <button onClick={() => this.exportToExcel(this.state.cariByCompany, {
                          totalPaid: this.state.totalPaid,
                          totalDebt: this.state.totalDebt,
                          balance: this.state.balance
                        })} className="btn btn-outline-info">
                          <i className="fa fa-file-excel-o"></i> Dışarı Aktar
                        </button>
                      )}

                    </div>
                  </div>
                  {code ? (
                    <>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-3 col-md-12">
                            <label htmlFor="time">Periyod</label>
                            <div className="form-group">
                              <select id='time' className="form-control" onChange={this.handleFilterChange}>
                                <option value="">Seçiniz</option>
                                <option value="daily">Günlük</option>
                                <option value="weekly">Haftalık</option>
                                <option value="monthly">Aylık</option>
                                <option value="yearly">Yıllık</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="start_time">Başlangıç Tarihi</label>
                              <input
                                id='start_time'
                                type="date"
                                className="form-control"
                                onChange={this.handleFilterChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="end_time">Bitiş Tarihi</label>
                              <input
                                id='end_time'
                                type="date"
                                className="form-control"
                                onChange={this.handleFilterChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="">&nbsp;</label>
                              {filterLoading ? (
                                <button className="btn btn-outline-primary btn-block"
                                  disabled={true}
                                  style={{ textAlign: "-webkit-center" }}>
                                  Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                    height={'24px'}
                                    color="#268bd2"></ReactLoading>
                                </button>
                              ) :
                                <button onClick={this.handleFilterSubmit}
                                  className="btn btn-outline-primary btn-block"
                                  type="submit">
                                  Filtrele
                                </button>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="col-lg-12">
                          {this.state.formData.id && (
                            <>
                              <div className="table-responsive mb-3">
                                <table className="table m-b-0 table-hover">
                                  <thead className="thead-light">
                                    <tr>
                                      <th>ID</th>
                                      <th>Tutar</th>
                                      <th>Ödeme Türü</th>
                                      <th>Tip</th>
                                      <th>Ödeme Tarihi</th>
                                      <th>Banka</th>
                                      <th>Açıklama</th>
                                      <th>İşlemler</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cariByCompany &&
                                      cariByCompany.map((receivable, index) => (
                                        <tr key={`receivable-${index}`}>
                                          <td>{receivable.id}</td>
                                          <td>
                                            {editIndex === index ? (
                                              <input
                                                type="text"
                                                name="amount"
                                                value={editedRow.amount}
                                                onChange={this.handleCollectionInputChange}
                                                className="form-control"
                                              />
                                            ) : (
                                              `${formattedPrice(receivable.amount)}`
                                            )}
                                          </td>
                                          <td>
                                            {editIndex === index ? (
                                              <select
                                                name="payment_type"
                                                value={editedRow.payment_type}
                                                onChange={this.handleCollectionInputChange}
                                                className="form-control"
                                              >
                                                <option value="Nakit">Nakit</option>
                                                <option value="Kredi Kartı">Kredi Kartı</option>
                                                <option value="Havale/EFT">Havale/EFT</option>
                                              </select>
                                            ) : (
                                              receivable.payment_type
                                            )}
                                          </td>
                                          <td>Borç</td>
                                          <td>
                                            {editIndex === index ? (
                                              <input
                                                type="date"
                                                name="collection_date"
                                                value={editedRow.collection_date}
                                                onChange={this.handleCollectionInputChange}
                                                className="form-control"
                                              />
                                            ) : (
                                              MainHelper.dateFormat(receivable.collection_date).split(' 0')[0]
                                            )}
                                          </td>
                                          <td>
                                            {editIndex === index ? (
                                              <select name="bank_id" id='bank_id'
                                                className="form-control"
                                                onChange={this.handleCollectionInputChange}>
                                                <option value="">Banka Seçiniz</option>
                                                {banks && (banks.map(bank => (
                                                  <option key={bank.id}
                                                    value={bank.id}>{bank.name}</option>
                                                )))}

                                              </select>
                                            ) : (
                                              receivable.bank?.name || ''
                                            )}
                                          </td>
                                          <td>
                                            {editIndex === index ? (
                                              <input
                                                type="text"
                                                name="description"
                                                value={editedRow.description}
                                                onChange={this.handleCollectionInputChange}
                                                className="form-control"
                                              />
                                            ) : (
                                              receivable.description
                                            )}
                                          </td>
                                          <td>
                                            {editIndex === index ? (
                                              <>
                                                {this.state.collectionUpdateLoading ? (
                                                  <button className="btn btn-success mr-2"
                                                    disabled={true}
                                                    style={{ textAlign: "-webkit-center" }}>
                                                    Lütfen Bekleyin...
                                                    <ReactLoading type="spin" width={'24px'}
                                                      height={'24px'}
                                                      color="#ffffff" />
                                                  </button>
                                                ) : (
                                                  <button type="button"
                                                    className="btn btn-success mr-2"
                                                    onClick={this.handleCollectionSave}>
                                                    Kaydet
                                                  </button>
                                                )}
                                                <button
                                                  className="btn btn-secondary"
                                                  onClick={this.handleCancel}
                                                >
                                                  Vazgeç
                                                </button>
                                              </>
                                            ) : (
                                              <>
                                                <button
                                                  className="btn btn-secondary mr-2"
                                                  onClick={() => this.handleCollectionEditClick(index, receivable)}
                                                >
                                                  <i className="icon-pencil"></i> Düzenle
                                                </button>
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={() => this.handleCollectionDelete(receivable.id)}
                                                >
                                                  <i className="icon-trash"></i> Sil
                                                </button>
                                              </>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                              <div className="mt-3 mb-3">
                                <div className="col-md-12 text-right">
                                  <p className="m-b-0">
                                    <b>Toplam Borç:</b> <b
                                      className="text-danger">{formattedPrice(this.state.calculates.total_debt) || 0}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Toplam Ödenen:</b> <b
                                      className="text-success">{formattedPrice(this.state.calculates.total_paid_debt) || 0}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Bakiye:</b>
                                    <b className={`${this.state.calculates.total_balance > 0 ? "text-success" : "text-danger"}`}>
                                      {formattedPrice(this.state.calculates.total_balance) || 0} {this.state.calculates.total_balance > 0 ? "(Alacak)" : (this.state.calculates.total_balance < 0 ? "(Borç)" : "")}
                                    </b>
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="body">
                      <div className="col-lg-12 justify-content-center d-flex">
                        <div className="col-md-6 text-center">
                          <div className="alert alert-danger"><i className="icon-ban"></i> Bu özelliği
                            kullanmak için plan yükseltin!
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    )
      ;
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
  customer_id: ioTReducer.customer_id
});

export default subscriptionPermissionsControl(withPermissions(withRouter(connect(mapStateToProps, { setCustomerID })(CustomerDetail))));
